<ng-container *ngrxLet="checkPassword$; let checkPassword">
    <div class="d-flex flex-column w-100" [style.visibility]="checkPassword?.isVisible ? 'visible' : 'hidden'">
        <div class="d-flex flex-row w-100 mt-1">
            <div class="point"></div>
            <div class="point"></div>
            <div class="point"></div>
            <div class="point"></div>
        </div>
        <div style="background: rgb(312, 198, 197, 0.5)" *ngIf="checkPassword?.strength! <= 1" class="p-1">
            <span>{{ 'VALIDATION_PASSWORD_UNSECURE' | translate }}</span>
        </div>
        <div style="background: rgb(251, 248, 229, 0.5)" *ngIf="checkPassword?.strength! === 2" class="p-1">
            <span>{{ 'VALIDATION_PASSWORD_MODEST' | translate }}</span>
        </div>
        <div style="background: rgb(221, 226, 246, 0.5)" *ngIf="checkPassword?.strength! === 3" class="p-1">
            <span>{{ 'VALIDATION_PASSWORD_GOOD' | translate }}</span>
        </div>
        <div style="background: rgb(226, 239, 218, 0.5)" *ngIf="checkPassword?.strength! === 4" class="p-1">
            <span>{{ 'VALIDATION_PASSWORD_EXCELLENT' | translate }}</span>
        </div>
    </div>
</ng-container>
